import { hooks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackSiteSaveInitiated = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_BEFORE_SITE_SAVE, () => {
    trackEvent(constants.events.SITE_SAVE_INITIATED);
  });
};

export default trackSiteSaveInitiated;
